export default __webpack_public_path__ + "static/media/700-min.96850ded.png";